import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  DataEngineTaxonomyDetailsDto,
  StageDefinitionDashboardDto,
  StageDefinitionDetailsInstanceDto,
  StageInstanceDashboardDto,
  SubstageInstanceStatusValues,
} from '@scale/shared-types';

export async function getStageDefinitionsForProject(
  projectId: string,
): Promise<StageDefinitionDashboardDto[]> {
  return apiFetch(
    null,
    `internal/sensor-fusion-legacy/data-engine/projects/${projectId}/stage-definitions`,
  );
}
export async function getBlueprintDataForProject(projectId: string): Promise<any> {
  return apiFetch(
    null,
    `internal/sensor-fusion-legacy/data-engine/projects/${projectId}/blueprints`,
  );
}

export async function getStageInstancesForTask(
  taskId: string,
): Promise<StageInstanceDashboardDto[]> {
  return apiFetch(
    null,
    `internal/sensor-fusion-legacy/data-engine/tasks/${taskId}/stage-instances`,
  );
}

interface IListArgs {
  id?: string;
  status?: SubstageInstanceStatusValues;
  page?: number;
  limit?: number;
  sortBy?: keyof StageDefinitionDetailsInstanceDto;
  sortOrder?: 'asc' | 'desc';
}

export async function getStageInstancesForStageDef(
  stageDefinitionId: string,
  args: IListArgs,
): Promise<{
  instances: StageDefinitionDetailsInstanceDto[];
  total_count: number;
}> {
  const queryParams = Object.entries(args)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  const queryParamsString = queryParams ? `?${queryParams}` : '';
  return apiFetch(
    null,
    `internal/sensor-fusion-legacy/data-engine/stage-definitions/${stageDefinitionId}/instances${queryParamsString}`,
  );
}

export async function getTaxonomyForStageDef(
  stageDefinitionId: string,
): Promise<DataEngineTaxonomyDetailsDto> {
  return apiFetch(
    null,
    `internal/sensor-fusion-legacy/data-engine/stage-definitions/${stageDefinitionId}/taxonomy`,
  );
}
